import { GET, PUT } from '../request'

export const getBalancesYear = ({ periodo, centro }) =>
  GET('/api/core/interno/contabilidad/balance-mensual/list/year', {
    periodo,
    centro
  })

export const getBalancesMes = ({ mes }) =>
  GET('/api/core/interno/contabilidad/balance-mensual/list/month', { mes })

export const actualizarObjetivo = ({ id, objetivo }) =>
  PUT('/api/core/interno/contabilidad/balance-mensual', { id, objetivo })
